var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"NotFoundScreen"},[_c('h1',{staticClass:"Title"},[_vm._v(" 404 ")]),_c('p',{staticClass:"Text"},[_vm._v(" Esta página de espartanas no existe ")])])
}]

export { render, staticRenderFns }